import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as ROUTES from './constants/routes';
import './App.css';

import DashboardPage from './pages/dashboard';
import LoginPage from './pages/auth/login';
import Layout from './components/layout/Layout';
import TradeHistoryPage from './pages/trade-history';
import StocksPage from './pages/stocks';
import StrategyPage from './pages/strategy';
import TechnicalAnalysisPage from './pages/technical-analysis';
import PerformanceMetricsPage from './pages/perfomance-metrics';
import ReportsPage from './pages/reports';
import SettingPage from './pages/setting';
import ProfilePage from './pages/profile/profile-page';
import SignUpPage from './pages/auth/signup';
import ForgetPasswordPage from './pages/auth/forget-password';
import TradersPage from './pages/traders';
import TradingCalendarPage from './pages/trading-calendar';
import { AuthProvider } from './context/AuthContext';
import EditPasswordPage from './pages/profile/edit-password-page';
import EditProfilePage from './pages/profile/edit-profile-page';
import ViewStockDetailsPage from './pages/stocks/view-stock-details';
import { AlertProvider } from './context/AlertContext';
import NotFoundPage from './pages/404';
import { CalendarProvider } from './context/CalendarContext';

function App() {
  return (
    <AlertProvider>
      <AuthProvider>
        <CalendarProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route
                  path={ROUTES.DASHBOARD_PAGE}
                  element={<DashboardPage />}
                ></Route>
                <Route
                  path={ROUTES.TRADE_HISTORY_PAGE}
                  element={<TradeHistoryPage />}
                ></Route>
                <Route
                  path={ROUTES.STOCKS_PAGE}
                  element={<StocksPage />}
                ></Route>
                <Route
                  path={ROUTES.STOCKS_DETAILS}
                  element={<ViewStockDetailsPage />}
                ></Route>
                <Route
                  path={ROUTES.TRADING_CALENDAR_PAGE}
                  element={<TradingCalendarPage />}
                ></Route>
                <Route
                  path={ROUTES.TRADERS_PAGE}
                  element={<TradersPage />}
                ></Route>
                <Route
                  path={ROUTES.STRATEGY_PAGE}
                  element={<StrategyPage />}
                ></Route>
                <Route
                  path={ROUTES.TECHNICAL_ANALYSIS_PAGE}
                  element={<TechnicalAnalysisPage />}
                ></Route>
                <Route
                  path={ROUTES.PERFORMANCE_PAGE}
                  element={<PerformanceMetricsPage />}
                ></Route>
                <Route
                  path={ROUTES.REPORTS_PAGE}
                  element={<ReportsPage />}
                ></Route>

                <Route
                  path={ROUTES.SETTING_PAGE}
                  element={<SettingPage />}
                ></Route>
                <Route path={ROUTES.PROFILE} element={<ProfilePage />}></Route>
                <Route
                  path={ROUTES.EDIT_PROFILE}
                  element={<EditProfilePage />}
                ></Route>
                <Route
                  path={ROUTES.CHANGE_PASSWORD}
                  element={<EditPasswordPage />}
                ></Route>
              </Route>
              <Route path={ROUTES.LOGIN} element={<LoginPage />}></Route>
              <Route path={ROUTES.SIGN_UP} element={<SignUpPage />}></Route>
              <Route
                path={ROUTES.FORGET_PASSWORD}
                element={<ForgetPasswordPage />}
              ></Route>
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </CalendarProvider>
      </AuthProvider>
    </AlertProvider>
  );
}

export default App;
